import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type HubspotContractSyncSummaryDTO = {
  pipelineId: string;
  pipelineLabel: string;
  dealsInPipeline: number;
  matched: number;
  cleared: number;
  propertiesTracked: number;
  unmatched: { dealId: string; dealName?: string; reason: string }[];
  unmatchedTotal: number;
  salesPipelineLabel?: string;
  salesDealsClosedWon: number;
  salesMatched: number;
  salesUnmatchedTotal: number;
  syncedAt: string;
  durationMs: number;
};

export type HubspotContractStageOptionDTO = { id: string; label: string; count: number };

export type HubspotContractPropertyOptionDTO = {
  name: string;
  label: string;
  values: { value: string; count: number }[];
  truncated: boolean;
};

export type HubspotContractFiltersDTO = {
  configured: boolean;
  lastSyncedAt?: string;
  studentsWithContract: number;
  stages: HubspotContractStageOptionDTO[];
  properties: HubspotContractPropertyOptionDTO[];
};

export const syncHubspotContracts: ApiDescription = {
  endpoint: '/admin/hubspot-contracts/sync',
  method: RequestsMethod.Post,
};

export type SyncHubspotContracts = ApiData<unknown, HubspotContractSyncSummaryDTO>;

export const getHubspotContractFilters: ApiDescription = {
  endpoint: '/admin/hubspot-contracts/filters',
  method: RequestsMethod.Get,
};

export type GetHubspotContractFilters = ApiData<unknown, HubspotContractFiltersDTO>;
